module.exports = __webpack_public_path__ + "static/img/dzcdhpb.6f20032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tab/dzcdhpb.png
// module id = p72X
// module chunks = 69